module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.i.type == 'String') ? [_vm._v("\n        " + _vm._s(_vm.getDataForPath(_vm.entity, _vm.i.field)) + "\n    ")] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Boolean') ? [_vm._v("\n        " + _vm._s(_vm._f("toSelect")(_vm.getDataForPath(_vm.entity, _vm.i.field), 'IsAndNot')) + "\n    ")] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Select') ? [_vm._v("\n         " + _vm._s(_vm._f("toSelect")(_vm.getDataForPath(_vm.entity, _vm.i.field), _vm.i.forSelectStoreName)) + "\n    ")] : _vm._e(), _vm._v(" "), (_vm.i.type == 'DateTime') ? [_vm._v("\n          " + _vm._s(_vm.getDataForPath(_vm.entity, _vm.i.field)) + "\n    ")] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Radio') ? [_c('el-radio-group', {
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }, _vm._l((_vm.$store.state[_vm.i.forSelectStoreName]), function(item) {
    return _c('el-radio', {
      staticClass: "radio",
      attrs: {
        "disabled": !!_vm.i.IsNotEdit,
        "label": item.Value
      }
    }, [_vm._v(_vm._s(item.Text))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Checkbox') ? [_c('el-checkbox-group', {
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }, _vm._l((_vm.$store.state[_vm.i.forSelectStoreName]), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "disabled": !!_vm.i.IsNotEdit,
        "label": item.Value
      }
    }, [_vm._v(_vm._s(item.Text))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Textarea') ? [_c('pre', {
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.getDataForPath(_vm.entity, _vm.i.field)))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'FunZTreeSelect') ? [(_vm.$store.state[_vm.i.forSelectStoreName]) ? _c('el-cascader', {
    staticClass: "ivu-cascader ivu-cascader-show-clear",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "placeholder": _vm.i.placeholder,
      "disabled": !!_vm.i.IsNotEdit,
      "options": _vm.$store.state[_vm.i.forSelectStoreName],
      "change-on-select": ""
    },
    model: {
      value: (_vm.i[_vm.i.forValueStoreName]),
      callback: function($$v) {
        _vm.$set(_vm.i, _vm.i.forValueStoreName, $$v)
      },
      expression: "i[i.forValueStoreName]"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'CheckboxList') ? [_c('el-checkbox-group', {
    model: {
      value: (_vm.i[_vm.i.forValueStoreName]),
      callback: function($$v) {
        _vm.$set(_vm.i, _vm.i.forValueStoreName, $$v)
      },
      expression: "i[i.forValueStoreName]"
    }
  }, _vm._l((_vm.$store.state[_vm.i.forSelectStoreName]), function(o) {
    return _c('el-checkbox', {
      attrs: {
        "label": o.Value,
        "disabled": !!_vm.i.IsNotEdit
      }
    }, [_c('span', [_vm._v(_vm._s(o.Text))])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'UploadImage') ? [_c('div', {
    staticClass: "el-form-group"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.i.field + '_UploadImage'
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.i.buttonName))])])]), _vm._v(" "), (_vm.entity[_vm.i.field]) ? _c('img', {
    class: _vm.i.class,
    attrs: {
      "src": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + _vm.entity[_vm.i.field]
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'UploadFile') ? [_c('div', {
    staticClass: "el-form-group"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.i.field + '_UploadFile'
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.i.buttonName))])])]), _vm._v(" "), (_vm.entity[_vm.i.field]) ? _c('a', {
    class: _vm.i.class,
    attrs: {
      "target": "_blank",
      "href": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + _vm.entity[_vm.i.field]
    }
  }, [_vm._v(_vm._s(_vm.g('$点击下载')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Editor') ? [_c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))]), _vm._v(" "), _c('quill-editor', {
    staticClass: "quill-editor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.i.type == 'TagList') ? [_vm._l((_vm.entity[_vm.i.field]), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": !_vm.i.hideNew,
        "disable-transitions": false
      },
      on: {
        "close": function() {
          if (_vm.i.OnRemove) {
            _vm.i.OnRemove(tag)
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getDataForPath(tag, _vm.i.tagField)) + "\n                ")])
  }), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top",
      "width": "600",
      "trigger": "hover"
    }
  }, [_c('popover-item', {
    attrs: {
      "config": _vm.i.popperConfig
    }
  }), _vm._v(" "), (!_vm.i.hideNew) ? _c('el-button', {
    staticClass: "button-new-tag",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "slot": "reference",
      "size": "small"
    },
    on: {
      "click": function() {
        if (_vm.i.OnRemove) {
          _vm.i.OnNewClick()
        }
      }
    },
    slot: "reference"
  }, [_vm._v("+ New")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'LabelSetting') ? [(!_vm.i.hideNew) ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "slot": "reference",
      "size": "small"
    },
    on: {
      "click": function() {
        _vm.$router.push('/LabelSetting')
        if (_vm.window.rootVue.thisWindow) {
          _vm.window.rootVue.thisWindow.LabelSetting_Key = _vm.i.fieldsKey;
          _vm.window.rootVue.thisWindow.LabelSetting = _vm.entity[_vm.i.field];
          _vm.window.rootVue.thisWindow.OnLabelSettingChange = function(LabelSetting) {
            _vm.$set(_vm.entity, _vm.i.field, LabelSetting)
            _vm.window.rootVue.thisWindow.LabelSetting = LabelSetting;
          }
        }

      }
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.g("$查看&设置")))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce468432"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/formtext_list_item.vue
// module id = 1297
// module chunks = 160